var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociallinkFacebookDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "28px",
    viewBox: "0 0 14 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-buy-cash-/-personal-info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1138.000000, -1854.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1126.000000, 1846.000000)",
    fill: "#343434"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0986118,35.3386588 L21.0986118,23.1847765 L25.1779059,23.1847765 L25.7892,18.4483059 L21.0986118,18.4483059 L21.0986118,15.4243059 C21.0986118,14.0527765 21.4790824,13.1181882 23.4456706,13.1181882 L25.9543765,13.1174824 L25.9543765,8.88077647 C25.5202588,8.82289412 24.0315529,8.69371765 22.2993176,8.69371765 C18.6830824,8.69371765 16.2075529,10.9017176 16.2075529,14.9548941 L16.2075529,18.4483059 L12.1169647,18.4483059 L12.1169647,23.1847765 L16.2075529,23.1847765 L16.2075529,35.3386588",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociallinkFacebookDark);
export default __webpack_public_path__ + "static/media/sociallink_facebook_dark.962e968c9213d8396dd523c8762d1c37.svg";
export { ForwardRef as ReactComponent };